var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { addError, handleValueChange, getValuesOrErrors as gve, focusNextIfAutofilled, } from '../../../utils/form';
function isMobileSafari() {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);
}
export function makeFormContext(_a) {
    var name = _a.name, formValues = _a.formValues, params = __rest(_a, ["name", "formValues"]);
    var Context = createContext(null);
    var Provider = function (props) {
        var _a = useState({}), errorMessages = _a[0], setErrorMessages = _a[1];
        var _b = useState(false), showRequired = _b[0], setShowRequired = _b[1];
        var _c = useState(true), incomplete = _c[0], setIncomplete = _c[1];
        var _d = useState(false), calledCompleted = _d[0], setCalledCompleted = _d[1];
        var errorText = Object.values(errorMessages).find(function (v) { return v; }) || '';
        var setErrorMessage = function (name, message) {
            setErrorMessages(function (e) {
                var _a;
                return (__assign(__assign({}, e), (_a = {}, _a[name] = message, _a)));
            });
        };
        var handleBlur = function (form, ev) {
            var element = ev.target;
            var name = element.name;
            var value = element.value;
            if (!formValues[name])
                return;
            var blurError = formValues[name].blurError;
            if (blurError) {
                var error = blurError(value, form);
                setErrorMessage(name, error);
                if (error) {
                    addError(element);
                }
            }
            if (isMobileSafari() && (name === 'email' || name === 'name')) {
                focusNextIfAutofilled(form, ev.target);
            }
        };
        var handleFocus = function (form, ev) { };
        var handleInput = function (form, ev) {
            var element = ev.target;
            var name = element.name;
            if (!isMobileSafari() || (name !== 'email' && name !== 'name')) {
                setTimeout(function () {
                    focusNextIfAutofilled(form, element);
                }, 0);
            }
        };
        var handleChange = function (form, ev) {
            var element = ev.target;
            var value = element.value;
            var name = element.name;
            if (!formValues[name])
                return;
            setShowRequired(false);
            handleValueChange(ev, formValues);
            var changeError = formValues[name].changeError;
            if (changeError) {
                var error = changeError(value, form);
                setErrorMessage(name, error);
                if (error) {
                    addError(element);
                }
            }
            var res = gve(form, formValues);
            var incomplete = !!res.errorElements.length;
            setIncomplete(incomplete);
            if (!incomplete && !calledCompleted && props.onCompleted) {
                setCalledCompleted(true);
                props.onCompleted(res.values);
            }
        };
        return (_jsx(Context.Provider, __assign({ value: {
                formValues: formValues,
                incomplete: incomplete,
                calledCompleted: calledCompleted,
                errorText: errorText,
                errorMessages: errorMessages,
                setErrorMessage: setErrorMessage,
                showRequired: showRequired,
                setShowRequired: setShowRequired,
                handleBlur: handleBlur,
                handleFocus: handleFocus,
                handleInput: handleInput,
                handleChange: handleChange,
            } }, { children: props.children })));
    };
    var useForm = function () {
        var context = useContext(Context);
        if (!context)
            throw new Error("".concat(name, " FormProvider not found in root"));
        return context;
    };
    return {
        Context: Context,
        Provider: Provider,
        useForm: useForm,
    };
}
//# sourceMappingURL=Form.js.map